
import { FC } from "react";
import ProjectItemPresentation from "../../presentation/project.item.presentation/project.item.presentation";
import { ProjectItemContainerProps } from "../../types/types";
const ProjectItemContainer: FC<ProjectItemContainerProps> = ({ project }) => {
  return <ProjectItemPresentation project={project} />
}

export default ProjectItemContainer
